import React from 'react'

function Product({ src, alt, name }) {
  return (
    <div className='w-full md:w-1/3 lg:w-1/4 h-96 p-3 bg-orange flex flex-col items-center gap-3 rounded-md'>
      <div className='w-full h-5/6'>
        <img className='h-full w-full rouneded-md' src={src} alt={alt} />
      </div>
      <div className='w-full h-1/6'>
        <h1 className='text-3xl text-center text-white font-roboto font-medium'>{name}</h1>
      </div>
    </div>
  )
}

export default Product